"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    applicationSwitcher: {
        affirm: 'Affirm',
        um: 'User Management',
        em: 'Eureka Math Navigator',
        phd: 'PhD Science Digital TE',
        ww: 'Wit & Wisdom Digital TE',
        inSync: 'Great Minds in Sync',
        otherResources: 'Other Resources',
        inkling: 'Digital TE',
    },
};
